var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinimumBasketImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 239.999C186.274 239.999 239.999 186.274 239.999 120C239.999 53.7257 186.274 0 120 0C53.7257 0 0 53.7257 0 120C0 186.274 53.7257 239.999 120 239.999Z",
    fill: "#E4E8E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192 239.999H48V84.7991C54.7872 84.7915 61.2942 82.092 66.0935 77.2927C70.8927 72.4935 73.5923 65.9864 73.5999 59.1992H166.4C166.392 62.5614 167.052 65.8916 168.34 68.9972C169.629 72.1028 171.52 74.9221 173.905 77.2919C176.275 79.6777 179.094 81.5697 182.2 82.8583C185.306 84.147 188.637 84.8066 192 84.7991V239.999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120 163.198C141.207 163.198 158.399 146.006 158.399 124.798C158.399 103.591 141.207 86.3984 120 86.3984C98.7918 86.3984 81.5996 103.591 81.5996 124.798C81.5996 146.006 98.7918 163.198 120 163.198Z",
    fill: "#EBEFE6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.575 142.901L119.999 129.325L106.423 142.901L101.897 138.376L115.474 124.799L101.897 111.223L106.423 106.698L119.999 120.274L133.575 106.698L138.101 111.223L124.524 124.799L138.101 138.376L133.575 142.901Z",
    fill: "#EB001B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.799 172.801H99.1994C96.5484 172.801 94.3994 174.95 94.3994 177.601C94.3994 180.252 96.5484 182.401 99.1994 182.401H140.799C143.45 182.401 145.599 180.252 145.599 177.601C145.599 174.95 143.45 172.801 140.799 172.801Z",
    fill: "#E4E8E0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155.199 192H84.799C82.1481 192 79.999 194.149 79.999 196.8C79.999 199.451 82.1481 201.6 84.799 201.6H155.199C157.85 201.6 159.999 199.451 159.999 196.8C159.999 194.149 157.85 192 155.199 192Z",
    fill: "#E4E8E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimumBasketImage);
export default __webpack_public_path__ + "static/media/minimumBasketImage.de8ac7b5b513bf939ca4b2e47097a7e4.svg";
export { ForwardRef as ReactComponent };